<template>
  <section id="pdf">
    <h1>Reporte de Clientes</h1>
    <div v-if="clientes.length > 0">
      <b-table class="box" :data="clientes">
        <b-table-column field="nombre" label="Nombre del cliente" v-slot="props">
          {{ props.row.nombre }}
        </b-table-column>

        <b-table-column field="ci" label="Cédula/RIF" v-slot="props">
          {{ props.row.ci }}
        </b-table-column>

        <b-table-column field="tipo" label="Tipo" v-slot="props">
          {{ props.row.tipo }}
        </b-table-column>

        <b-table-column field="telefono" label="Teléfono" v-slot="props">
          {{ props.row.telefono }}
        </b-table-column>
      </b-table>
    </div>
    <div v-if="clientes.length < 1">
      <p>No existen clientes en el sistema.</p>
    </div>
  </section>
</template>

<script>
import Printd from 'printd'
import HttpService from '@/Servicios/HttpService';

export default {
  name: 'PDFClientes',

  data: () => ({
    clientes: [],
  }),

  mounted() {
    document.body.style.opacity = '0'
    const accion = 'obtener'

    const f = {
      nombre: (this.$route.query.nombre || '').trim().toLocaleLowerCase(),
      ci: (this.$route.query.ci || '').trim().toLocaleLowerCase(),
      tipo: (this.$route.query.tipo || '').trim().toLocaleLowerCase(),
      telefono: (this.$route.query.telefono || '').trim().toLocaleLowerCase(),
      direccion: (this.$route.query.direccion || '').trim().toLocaleLowerCase(),
    }
    const hayFiltros = Object.values(f).some(Boolean)

    HttpService.obtenerConConsultas('clientes.php', { accion })
      .then(resultado => {
        let clientes = Array.isArray(resultado)
          ? resultado
          : ((resultado && resultado.clientes) || [])
        if (hayFiltros) {
          clientes = clientes.filter(cliente => {
            return (!f.nombre || String(cliente.nombre || '').toLocaleLowerCase().includes(f.nombre)) &&
              (!f.ci || String(cliente.ci || '').toLocaleLowerCase().includes(f.ci)) &&
              (!f.tipo || String(cliente.tipo || '').toLocaleLowerCase().includes(f.tipo)) &&
              (!f.telefono || String(cliente.telefono || '').toLocaleLowerCase().includes(f.telefono)) &&
              (!f.direccion || String(cliente.direccion || '').toLocaleLowerCase().includes(f.direccion))
          })
        }
        this.clientes = clientes
        return new Promise(res => setTimeout(res, 100))
      }).then(() => {
        const d = new Printd()
        const table = document.querySelector('#pdf')

        d.onAfterPrint(() => window.close())
        d.print(table, ['/pdf.css'])
      })
  },
}
</script>
